import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect, useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Container, Row, Col, Card, CardBody, Input, Button } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
// import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import EditableLabel from "editable-label-react"
// import EditableLabel from "react-editable-label"
import ReactQuill from "react-quill"
import Dropzone from "react-dropzone"

//Components and store
import * as ticketQueryAction from "../../../store/cmFpc2VUaWNrZXQ/actions"
import * as permissionAction from "../../../store/cGVybWlzc2lvbg/actions"
// import notificationSound from "../../../assets/sounds/iphone_circle.mp3"
import SimpleReactValidator from "simple-react-validator"
import api from "helpers/Api"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
// import NotificationDropdown from "components/CommonForBoth/TopbarDropdown/NotificationDropdown"
// import moment from "moment"
// import addNotification from "react-push-notification"

const RaiseTicket = (props) => {
  const title = "Raise Ticket"

  const { dispatch } = props
  // console.log(dispatch)

  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const ticketStoreUpdate = useSelector((state) => state.raiseTicket)
  // const { user = {} } = useSelector((state) => state.session)
  // const empId = localStorage.getItem("empId")
  // console.log(user, "user")
  // const userId = !isEmpty(user) ? user.id : empId
  useEffect(() => {
    dispatch(permissionAction.loadEmployee())
    dispatch(ticketQueryAction.loadRecordsMetaData())
    dispatch(ticketQueryAction.loadPriorityRecordsMetaData())
    dispatch(ticketQueryAction.loadSubLabelDetails({ status: "active" }))
    // dispatch(ticketQueryAction.loadTicketNotifications({ userId: userId }))
  }, [])

  //Reducer state
  const {
    // ticket_details = [],
    // employee_sub_labels = [],
    recordsMetaData = {},
    priorityMetaData = {},
    // ticket_notifications = [],
    // subLabel_details = [],
  } = ticketStoreUpdate

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )
  const { employee_list = [] } = permissionUpdate

  //On Change
  const handleEmployeeLabel = (e) => {
    setEmployeeLabel(e)
    setEmployeeSubLabel([])
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    })
  }

  // Notifications data
  // const [ticketNotification, setTicketNotification] = useState(false)
  // const [notificationsDataArray, setNotificationsDataArray] = useState([])

  // const [notificationData, setNotificationData] = useState({
  //   title: "",
  //   notificationId: "",
  //   description: "",
  //   createdDate: "",
  //   dateNow: "",
  //   minDiff: "",
  //   createdDateMin: "",
  //   dateNowMin: "",
  //   addTicket: false,
  // })

  //Employee List Options
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.name = element.name
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)

  // console.log(employeeOptions, "employeeOptions")

  //Ticket editable
  const [editableText, setEditableText] = useState("")
  const [priority, setPriority] = useState([])

  // Members section
  const [ticketDescription, setTicketDescription] = useState("")
  const [dataClear, setDataClear] = useState(false)
  const [ccMemberCard, setCcMemberCard] = useState(false)
  const [membersList, setMembersList] = useState([])
  const [ccMembersList, setCcMembersList] = useState([])
  const [memberCard, setMemberCard] = useState(false)
  const [memberAdd, setMemberAdd] = useState(false)
  const [ccMemberAdd, setCcMemberAdd] = useState(false)
  // const [errorMessage, setErrorMessage] = useState("")

  //Members Modal Data
  const [membersModalData, setMembersModalData] = useState({
    userProfile: "",
    userName: "",
  })
  const [ccMembersModalData, setCcMembersModalData] = useState({
    userProfile: "",
    userName: "",
  })

  //Lables section
  // console.log(errorMessage, "errorMessage")
  // const [addNewLabel, setAddNewLabel] = useState(false)
  const [addNewLabel, setAddNewLabel] = useState(false)
  const [newLabelData, setNewLabelData] = useState("")
  // const [newLabelData, setNewLabelData] = useState("")
  const [ticketGroup, setTicketGroup] = useState([])
  const [ticketAttachmentFiles, setTicketAttachmentFiles] = useState([])
  const [ticketAttachment, setTicketAttachment] = useState([])

  //Employee Label
  const [employeeLabel, setEmployeeLabel] = useState([])
  const [employeeSubLabel, setEmployeeSubLabel] = useState([])
  const [employeeLabelName, setEmployeeLabelName] = useState("")

  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["label"],
  }
  // console.log(employeeLabel, "employeeLabel")
  console.log(employeeLabelName, "employeeLabelName")
  // console.log(ticketAttachmentFiles, "ticketAttachmentFiles")
  // console.log(membersList, "membersList")
  //Ticket attachment section
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const handleTicketAttachmentFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    if (files) {
      // console.log("qqqq", e.target.files)

      var file = files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = ticketAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setTicketAttachment(teamUploadValue)
          }
        })
      }
    }
    setTicketAttachmentFiles(files)
  }

  // console.log(ticketAttachment, "ticketAttachment")

  //Modules
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [2, 4, 6, 8, 10, 12, 14, 16, 18, 19, 24, 32, 38, 64, 72] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video", "mic"],
      [
        {
          color: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
      [
        {
          background: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
    ],
  }
  //Formats
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "video",
    "mic",
    "background",
    "align",
    "size",
    "font",
  ]

  //Ticket label color choose funcitonality

  // const labelColorsData =
  //   !isEmpty(recordsMetaData) && recordsMetaData.labelData
  //     ? recordsMetaData.labelData.map((data) => {
  //         return {
  //           label: data.label,
  //           color: data.colorCode,
  //           subLabel: data.subLabel,
  //           subLabelId: data.subLabelId,
  //           value: data.value,
  //         }
  //       })
  //     : []

  // console.log(labelColorsData, "labelColorsData")

  // const labelColors = [
  //   {
  //     id: 1,
  //     color: "#34c28f",
  //   },
  //   {
  //     id: 2,
  //     color: "#f1c40f",
  //   },
  //   {
  //     id: 3,
  //     color: "#6793e4",
  //   },
  //   {
  //     id: 4,
  //     color: "#172b4d",
  //   },
  //   {
  //     id: 5,
  //     color: "#eb65f9",
  //   },
  //   {
  //     id: 6,
  //     color: "red",
  //   },
  // ]

  // console.log(labelColorsData, "labelColorsData")
  //Members list name
  const memberListName =
    !isEmpty(membersList) && membersList.length > 0
      ? membersList.map((data) => data.value)
      : ""
  const ccMemberListName =
    !isEmpty(ccMembersList) && ccMembersList.length > 0
      ? ccMembersList.map((data) => data.value)
      : []
  // const [toggleData, setToggleData] = useState(false)
  // const sound = new Audio(notificationSound)

  //Api section
  const addTicketQuery = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const ticketQuery = {
        title: editableText,
        description: ticketDescription,
        attachments:
          !isEmpty(ticketAttachment) && ticketAttachment.length > 0
            ? ticketAttachment.map((data) => data)
            : "",
        priority: priority.value,
        reportingTo: memberListName,
        // subLableId: subLabel.value,
        labelId: !isEmpty(employeeLabel) ? employeeLabel.value : "",
        // employeeLabelName: !isEmpty(employeeLabel) ? employeeLabel.label : "",
        employeeSubLabelId: !isEmpty(employeeSubLabel)
          ? employeeSubLabel.value
          : "",
        employeeSubLabelName: isEmpty(employeeSubLabel) ? newLabelData : "",
        // lableId: labelData.value,
        reportingBc: ccMemberListName,
        ticketGroupId: ticketGroup.value,
      }
      // console.log(ticketQuery, "ticketQuery")
      if (!isEmpty(editableText)) {
        dispatch(ticketQueryAction.addTicketQuery(ticketQuery))

        setTimeout(() => {
          dispatch(
            ticketQueryAction.loadTicketQuery({
              page: 1,
              limit: 50,
            })
          )
          toast.success("Ticket Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
          // api
          //   .post("/get_all_ticket_notifications", { userId: userId })
          //   .then((res) => {
          //     res.data && res.data.data
          //     setTicketNotification(true)
          //     const notificationArray =
          //       res && res.data && res.data.data.length > 0 ? res.data.data : []
          //     // localStorage.setItem("notification", notificationArray)

          //     const notificationsLastArray =
          //       res && res.data && res.data.data.length > 0
          //         ? res.data.data[res.data.data.length - 1]
          //         : ""
          //     // console.log(notificationsLastArray, "notificationsLastArray")
          //     // if (dataClear == true) {
          //     const notifications =
          //       !isEmpty(notificationsLastArray) &&
          //       notificationsLastArray &&
          //       notificationsLastArray.toEmpIds &&
          //       notificationsLastArray.toEmpIds.length > 0
          //         ? notificationsLastArray.toEmpIds.find(
          //             (employee) => employee.empId == userId
          //           )
          //         : ""

          //     console.log(notifications, "notifications")
          //     const createdDate = moment(
          //       notificationsLastArray.createdAt
          //     ).format("DD-MM-YYYY hh")
          //     const dateNow = moment().format("DD-MM-YYYY hh")
          //     const createdDateMin = moment(
          //       notificationsLastArray.createdAt
          //     ).format("mm")
          //     const dateNowMin = moment().format("mm")

          //     const minDiff = parseInt(dateNowMin - createdDateMin)

          //     if (
          //       notifications.empId == userId &&
          //       createdDate == dateNow &&
          //       minDiff <= 1
          //     ) {
          //       setNotificationData({
          //         notificationId: notifications,
          //         title: notificationsLastArray.title,
          //         description: notificationsLastArray.description,
          //         createdDate: createdDate,
          //         dateNow: dateNow,
          //         minDiff: minDiff,
          //         createdDateMin: createdDateMin,
          //         dateNowMin: dateNowMin,
          //         addTicket: dataClear ? dataClear : true,
          //       })
          //       sound.play()
          //       addNotification({
          //         title: notificationsLastArray.title,
          //         subtitle: "Notifications",
          //         message: notificationsLastArray.description,
          //         closeButton: "Close",
          //         // onClick: () => setToggleData(true),
          //         theme: "darkblue",
          //         duration: 100000,
          //         native: true, // when using native, your OS will handle theming.
          //       })
          //     }

          //     // setTimeout(() => {
          //     //   setTicketNotification(false)
          //     // }, 500)
          //     setNotificationsDataArray(notificationArray)
          //   })
          // setEditableText("Click To Edit")
          dataClearValues()
          setDataClear(true)
        }, 1200)
      }
    } else {
      simpleValidator.current.showMessages()
      if (
        isEmpty(editableText) &&
        !isEmpty(ticketDescription) &&
        ticketAttachment.length > 0
      ) {
        toast.error("Enter The Ticket Name", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }
      forceUpdate(1)
    }
  }

  //Member card submit
  const addMemberCard = () => {
    setMemberCard(false)
    setMemberAdd(true)
  }
  const addCcMemberCard = () => {
    setCcMemberCard(false)
    setCcMemberAdd(true)
  }

  const [resetManager, setResetManager] = useState(false)
  // const [resetSubManager, setResetSubManager] = useState(false)
  const [editKey, setEditKey] = useState(false)
  //Data clear
  // useEffect(() => {
  //   if (dataClear == true) {
  const dataClearValues = () => {
    setMembersList([])
    setEditKey(true)
    setTicketGroup([])
    setTimeout(() => {
      setEditKey(false)
    }, 0)
    setResetManager(true)
    setEmployeeLabel([])
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    setEditableText("Subject")
    setCcMembersList([])
    setTicketDescription("")
    setNewLabelData("")
    setAddNewLabel(false)
    setTicketAttachmentFiles([])
    setPriority([])
  }
  // setEditableText("")
  // }
  // }, [dataClear])

  console.log(dataClear, "dataClear")

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Tickets"} breadcrumbItem={title} />
          <Row>
            {/* <Notifications /> */}
            <div
              style={{
                display: "none",
              }}
            >
              {/* <NotificationDropdown
                notifications_data={notificationsDataArray}
                ticketsData={notificationData}
                key={notificationsDataArray}
                // toggleClick={toggleData == true ? true : false}
                ticketNotification={ticketNotification == true ? true : false}
              /> */}
            </div>

            <Col xl="12" md="12" lg="12" xs={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col xl="12" lg="12" md="12" sm="12" xs="12">
                      <div className="d-flex flex-row justify-content-between">
                        <div className="d-flex flex-row">
                          <i
                            className="fa fa-list-alt"
                            style={{ fontSize: "19px", marginTop: "5px" }}
                          ></i>
                          <h2 style={{ color: "#172b4d", marginLeft: "18px" }}>
                            <EditableLabel
                              labelClassName="myLabelClass"
                              inputClassName="my-input-class"
                              inputWidth={"390px"}
                              key={editKey}
                              inputHeight="40px"
                              initialValue="Subject"
                              labelFontWeight="bold"
                              inputFontWeight={400}
                              value={editableText ? editableText : "Subject"}
                              onChange={(e) => setEditableText(e.target.value)}
                              onFocus={(t) => console.log("focus", t)}
                              onFocusOut={(t) => console.log("focus out", t)}
                            />
                            {simpleValidator.current.message(
                              "title",
                              editableText,
                              "required"
                            )}
                          </h2>
                          <span
                            style={{ color: "red" }}
                            className="ticket-required mx-2"
                          >
                            *
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Row className="d-flex flex-row">
                      <Col xl="6" lg="6" md="6" sm="6" xs="6">
                        <Row>
                          <Col
                            xl="4"
                            lg="4"
                            md="4"
                            sm="12"
                            xs="12"
                            className="mt-3"
                          >
                            <div
                              className="d-flex flex-row"
                              style={{ marginLeft: "38px" }}
                            >
                              <div className="d-flex flex-column">
                                <h5>
                                  Direct Members{" "}
                                  {/* <span 
                                 style={{ color: "red" }}
                                  className="ticket-required"
                                > 
                                  *
                                 </span>  */}
                                </h5>
                                <div className="d-flex flex-row">
                                  {memberAdd == true &&
                                  !isEmpty(membersList) &&
                                  membersList.length > 0 ? (
                                    membersList.map((data, index) => {
                                      const memberName = !isEmpty(data)
                                        ? data.name.slice(0, 1)
                                        : ""
                                      return (
                                        <div
                                          alt="Sample"
                                          // src="https://picsum.photos/300/200"
                                          className="member-img mx-1"
                                          id="PopoverClick"
                                          style={{
                                            position: "relative",
                                          }}
                                          key={index}
                                          type="button"
                                          onClick={() => {
                                            setMembersModalData({
                                              userProfile: memberName,
                                              userName: data.name,
                                            })
                                            setMemberCard(true)
                                          }}
                                        >
                                          <p
                                            style={{
                                              position: "absolute",
                                              top: "7px",
                                              color: "#172b4d",
                                              left: "13.5px",
                                              fontWeight: 800,
                                              fontSize: "14px",
                                            }}
                                          >
                                            {memberName}
                                          </p>
                                        </div>
                                      )
                                    })
                                  ) : (
                                    <div
                                      alt="Sample"
                                      // src="https://picsum.photos/300/200"
                                      className="member-img"
                                      id="PopoverClick"
                                      style={{
                                        position: "relative",
                                      }}
                                      type="button"
                                      onClick={() => setMemberCard(true)}
                                    >
                                      <p
                                        style={{
                                          position: "absolute",
                                          top: "7px",
                                          color: "#172b4d",
                                          left: "11.5px",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <i className="fas fa-user"></i>
                                      </p>
                                    </div>
                                  )}

                                  <div
                                    className="member-img-plus mx-2"
                                    id="PopoverClick"
                                    style={{
                                      position: "relative",
                                    }}
                                    type="button"
                                    onClick={() => setMemberCard(true)}
                                  >
                                    <p
                                      style={{
                                        position: "absolute",
                                        top: "7px",
                                        left: "11.5px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </p>
                                  </div>
                                </div>
                                {/* {simpleValidator.current.message(
                                "membersList",
                                membersList,
                                "required"
                              )} */}
                                {memberCard && (
                                  <Modal
                                    backdrop="static"
                                    show={memberCard}
                                    onHide={() => setMemberCard(false)}
                                    size="sm"
                                    style={{
                                      margin: "10% -30%",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <Modal.Header
                                      style={{
                                        backgroundColor: "blue",
                                        height: "70px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                        }}
                                        className="d-flex flex-row"
                                      >
                                        <div
                                          alt="Sample"
                                          // src="https://picsum.photos/300/200"
                                          className="member-img-popover"
                                          // id="PopoverClick"
                                          // type="button"
                                          style={{
                                            position: "absolute",
                                            top: "35px",
                                            left: "2px",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <p
                                            style={{
                                              position: "absolute",
                                              top: "10px",
                                              left: "23px",
                                              color: "#172b4d",
                                              fontSize: "31px",
                                              fontWeight: 800,
                                            }}
                                          >
                                            {!isEmpty(
                                              membersModalData.userProfile
                                            ) ? (
                                              membersModalData.userProfile
                                            ) : (
                                              <>
                                                {" "}
                                                <i className="fas fa-user"></i>
                                              </>
                                            )}
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            marginLeft: "79px",
                                            marginTop: "36px",
                                          }}
                                        >
                                          <p className="username-label">
                                            {!isEmpty(membersModalData.userName)
                                              ? membersModalData.userName
                                              : "No Username"}
                                          </p>
                                          <p className="username-label1">
                                            @
                                            {!isEmpty(membersModalData.userName)
                                              ? membersModalData.userName
                                              : "No Username"}
                                          </p>
                                        </div>
                                        <i
                                          className="fa fa-times"
                                          onClick={() => setMemberCard(false)}
                                          style={{
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "18px",
                                            left: "264px",
                                          }}
                                        ></i>
                                      </div>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <Row className="mt-4">
                                        <Col
                                          xl="12"
                                          lg="12"
                                          md="12"
                                          sm="12"
                                          xs="12"
                                        >
                                          <Select
                                            isMulti
                                            name="membersList"
                                            value={membersList}
                                            onChange={(e) => setMembersList(e)}
                                            placeholder="Select Members List"
                                            options={employeeOptions}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mt-4">
                                        <Col
                                          xl="12"
                                          lg="12"
                                          md="12"
                                          sm="12"
                                          xs="12"
                                          // style={{
                                          //   borderTop: "1.5px solid #b9bfc4",
                                          // }}
                                        >
                                          <div
                                            style={{
                                              padding: "4px",
                                              background: "#bfbfbf",
                                              color: "black",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              textAlign: "center",
                                            }}
                                            className="member-view-profile mt-3"
                                            onClick={() => {
                                              setMembersList([])
                                              setMemberCard(false)
                                            }}
                                          >
                                            Remove Card
                                          </div>
                                        </Col>
                                      </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <div className="d-flex flex-row">
                                        <button
                                          onClick={() => setMemberCard(false)}
                                          style={{
                                            background: "#f00707b7",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "white",
                                            padding: "6px",
                                            borderRadius: "4px",
                                          }}
                                        >
                                          Close
                                        </button>
                                        <button
                                          onClick={() => addMemberCard()}
                                          className="mx-2"
                                          style={{
                                            background: "#34c28f",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "white",
                                            padding: "6px",
                                            borderRadius: "4px",
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </Modal.Footer>
                                  </Modal>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col
                            xl="4"
                            lg="4"
                            md="4"
                            sm="12"
                            xs="12"
                            className="mt-3"
                          >
                            <div
                              className="d-flex flex-row"
                              style={{ marginLeft: "38px" }}
                            >
                              <div
                                className="d-flex flex-column"
                                //  style={{ marginLeft: "82px" }}
                              >
                                <h5>Indirect Members </h5>
                                <div className="d-flex flex-row">
                                  {ccMemberAdd == true &&
                                  !isEmpty(ccMembersList) &&
                                  ccMembersList.length > 0 ? (
                                    ccMembersList.map((data, index) => {
                                      const ccmemberName = !isEmpty(data)
                                        ? data.name.slice(0, 1)
                                        : ""
                                      return (
                                        <div
                                          alt="Sample"
                                          // src="https://picsum.photos/300/200"
                                          className="member-img mx-1"
                                          id="PopoverClick"
                                          style={{
                                            position: "relative",
                                          }}
                                          key={index}
                                          type="button"
                                          onClick={() => {
                                            setCcMembersModalData({
                                              userProfile: ccmemberName,
                                              userName: data.name,
                                            })
                                            setCcMemberCard(true)
                                          }}
                                        >
                                          <p
                                            style={{
                                              position: "absolute",
                                              top: "7px",
                                              color: "#172b4d",
                                              left: "11.5px",
                                              fontWeight: 800,
                                              fontSize: "14px",
                                            }}
                                          >
                                            {ccmemberName}
                                          </p>
                                        </div>
                                      )
                                    })
                                  ) : (
                                    <>
                                      <div
                                        alt="Sample"
                                        // src="https://picsum.photos/300/200"
                                        className="member-img mx-1"
                                        id="PopoverClick"
                                        style={{
                                          position: "relative",
                                        }}
                                        type="button"
                                        onClick={() => setCcMemberCard(true)}
                                      >
                                        <p
                                          style={{
                                            position: "absolute",
                                            top: "7px",
                                            color: "#172b4d",
                                            left: "11.5px",
                                            fontSize: "14px",
                                          }}
                                        >
                                          <i className="fas fa-user"></i>
                                        </p>
                                      </div>
                                    </>
                                  )}

                                  <div
                                    className="member-img-plus mx-2"
                                    id="PopoverClick"
                                    style={{
                                      position: "relative",
                                    }}
                                    type="button"
                                    onClick={() => setCcMemberCard(true)}
                                  >
                                    <p
                                      style={{
                                        position: "absolute",
                                        top: "7px",
                                        left: "11.5px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </p>
                                  </div>
                                </div>

                                {ccMemberCard && (
                                  <Modal
                                    backdrop="static"
                                    show={ccMemberCard}
                                    onHide={() => setCcMemberCard(false)}
                                    size="sm"
                                    style={{
                                      margin: "10% -30%",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <Modal.Header
                                      style={{
                                        backgroundColor: "blue",
                                        height: "70px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                        }}
                                        className="d-flex flex-row"
                                      >
                                        <div
                                          alt="Sample"
                                          // src="https://picsum.photos/300/200"
                                          className="member-img-popover"
                                          // id="PopoverClick"
                                          // type="button"
                                          style={{
                                            position: "absolute",
                                            top: "35px",
                                            left: "2px",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <p
                                            style={{
                                              position: "absolute",
                                              top: "10px",
                                              left: "21px",
                                              color: "#172b4d",
                                              fontSize: "31px",
                                              fontWeight: 800,
                                            }}
                                          >
                                            {/* {!isEmpty(ccMembersList) && ccMembersList.length > 0 ? ccMembersList.map(data=> data.name) : <><i className="fas fa-user"></i></>} */}
                                            {!isEmpty(
                                              ccMembersModalData.userProfile
                                            ) ? (
                                              ccMembersModalData.userProfile
                                            ) : (
                                              <>
                                                {" "}
                                                <i className="fas fa-user"></i>
                                              </>
                                            )}
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            marginLeft: "79px",
                                            marginTop: "36px",
                                          }}
                                        >
                                          <p className="username-label">
                                            {!isEmpty(
                                              ccMembersModalData.userName
                                            )
                                              ? ccMembersModalData.userName
                                              : "No Username"}
                                          </p>
                                          <p className="username-label1">
                                            @
                                            {!isEmpty(
                                              ccMembersModalData.userName
                                            )
                                              ? ccMembersModalData.userName
                                              : "No Username"}
                                          </p>
                                        </div>
                                        <i
                                          className="fa fa-times"
                                          onClick={() => setCcMemberCard(false)}
                                          style={{
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            cursor: "pointer",
                                            position: "absolute",
                                            top: "18px",
                                            left: "264px",
                                          }}
                                        ></i>
                                      </div>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <Row className="mt-4">
                                        <Col
                                          xl="12"
                                          lg="12"
                                          md="12"
                                          sm="12"
                                          xs="12"
                                        >
                                          <Select
                                            isMulti
                                            name="ccMembersList"
                                            value={ccMembersList}
                                            onChange={(e) =>
                                              setCcMembersList(e)
                                            }
                                            placeholder="Select CC Members List"
                                            options={employeeOptions}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mt-4">
                                        <Col
                                          xl="12"
                                          lg="12"
                                          md="12"
                                          sm="12"
                                          xs="12"
                                        >
                                          <div
                                            style={{
                                              padding: "4px",
                                              background: "#bfbfbf",
                                              color: "black",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              textAlign: "center",
                                            }}
                                            className="mt-3"
                                            onClick={() => {
                                              setCcMembersList([])
                                              setCcMemberCard(false)
                                            }}
                                          >
                                            Remove Card
                                          </div>
                                        </Col>
                                      </Row>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <div className="d-flex flex-row">
                                        <button
                                          onClick={() => setCcMemberCard(false)}
                                          style={{
                                            background: "#f00707b7",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "white",
                                            padding: "6px",
                                            borderRadius: "4px",
                                          }}
                                        >
                                          Close
                                        </button>
                                        <button
                                          onClick={() => addCcMemberCard()}
                                          style={{
                                            background: "#34c28f",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "white",
                                            padding: "6px",
                                            borderRadius: "4px",
                                          }}
                                          className="mx-2"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </Modal.Footer>
                                  </Modal>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col
                            xl="4"
                            lg="4"
                            md="12"
                            sm="12"
                            style={{
                              //marginRight: "30px",
                              // marginLeft: "36px",
                              marginTop: "-7.5px",
                            }}
                          >
                            <div className="d-flex flex-row justify-content-between mt-4">
                              <div style={{ width: "92%", marginLeft: "auto" }}>
                                <h5>
                                  Ticket Group{" "}
                                  {/* <span
                                  style={{ color: "red" }}
                                  className="ticket-required"
                                >
                                  *
                                </span> */}
                                </h5>
                              </div>
                            </div>
                            <div style={{ width: "92%", marginLeft: "auto" }}>
                              <Select
                                name="ticketGroup"
                                value={ticketGroup}
                                onChange={(e) => {
                                  setTicketGroup(e)
                                }}
                                options={
                                  !isEmpty(recordsMetaData.ticketGroupOptions)
                                    ? recordsMetaData.ticketGroupOptions
                                    : []
                                }
                                placeholder="Select Ticket Group"
                              />
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              {/* {simpleValidator.current.message(
                          "TIcket Group",
                          ticketGroup,
                          "required"
                        )} */}
                            </div>
                          </Col>

                          {/* Department card */}
                          {/* <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="mt-4"
                        >
                          <Row
                            className="d-flex flex-row"
                            style={{ marginLeft: "30px" }}
                          >
                            <Col
                              xl="6"
                              lg="6"
                              md="6"
                              sm="6"
                              xs="6"
                              className="d-flex flex-column"
                            >
                              <h5>
                                Department
                                <span
                                  style={{ color: "red" }}
                                  className="ticket-required mx-1"
                                >
                                  *
                                </span>
                              </h5>
                              <Row className="d-flex flex-row">
                                <Col xl="8" lg="8" md="8" sm="8" xs="8">
                                  <div>
                                    <Select
                                      name="labelData"
                                      value={labelData}
                                      onChange={(e) => {
                                        handleLabel(e)
                                      }}
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.labelData
                                          : []
                                      }
                                      placeholder="Select Label"
                                    />
                                    {simpleValidator.current.message(
                                      "labelData",
                                      labelData,
                                      "required"
                                    )}
                                  </div>
                                </Col>
                                <Col
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="2"
                                  xs="2"
                                  style={{ marginLeft: "-27px" }}
                                >
                                  <div
                                    className="label-img-plus mx-2"
                                    id="PopoverClick"
                                    style={{
                                      position: "relative",
                                    }}
                                    type="button"
                                    onClick={() => setLabelCard(true)}
                                  >
                                    <p
                                      style={{
                                        position: "absolute",
                                        top: "7px",
                                        left: "11.5px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </p>
                                  </div>
                                </Col>
                              </Row>

                              {labelCard && (
                                <Modal
                                  backdrop="static"
                                  show={labelCard}
                                  onHide={() => setLabelCard(false)}
                                  size="sm"
                                  style={{ borderRadius: "4px" }}
                                >
                                  <Modal.Header className="d-flex flex-row">
                                    <div className="d-flex flex-row justify-content-center">
                                      <h5>Labels</h5>
                                    </div>
                                    <div className="d-flex flex-row justify-content-end">
                                      <i
                                        className="fa fa-times"
                                        onClick={() => setLabelCard(false)}
                                        style={{
                                          // color: "#ffffff",
                                          fontSize: "14px",
                                          cursor: "pointer",
                                          float: "right",
                                          // position: "absolute",
                                          // top: "18px",
                                          // left: "264px",
                                        }}
                                      ></i>
                                    </div>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row className="mt-2">
                                      <Col
                                        xl="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        xs="12"
                                      >
                                        <Input
                                          name="labelSearch"
                                          value={labelSearch}
                                          placeholder="Enter The Value"
                                          onChange={(e) =>
                                            setLabelSearch(e.target.value)
                                          }
                                          // options={labelColors}
                                        />
                                      </Col>
                                      <Col
                                        xl="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        xs="12"
                                      >
                                        <Row>
                                          <Col
                                            xl="12"
                                            lg="12"
                                            md="12"
                                            sm="12"
                                            xs="12"
                                          >
                                            <div className="mt-4">Labels</div>
                                          </Col>
                                          <Col
                                            xl="12"
                                            lg="12"
                                            md="12"
                                            sm="12"
                                            xs="12"
                                          >
                                            {!isEmpty(labelColors) &&
                                            labelColors.length > 0
                                              ? labelColors.map(
                                                  (data, index) => {
                                                    return (
                                                      <Row
                                                        className="d-flex flex-row mt-2"
                                                        key={index}
                                                      >
                                                        <Col
                                                          xl="1"
                                                          lg="1"
                                                          md="1"
                                                          sm="1"
                                                          xs="1"
                                                        >
                                                          <Input
                                                            type="checkbox"
                                                            name="labelCheckbox"
                                                            value={
                                                              labelCheckbox
                                                            }
                                                            onChange={(e) => {
                                                              setLabelCheckbox(
                                                                e.target
                                                                  .checked,
                                                                index
                                                              )
                                                              setLabelColorCode(
                                                                data.color
                                                              )
                                                            }}
                                                          />{" "}
                                                        </Col>
                                                        <Col
                                                          xl="10"
                                                          lg="10"
                                                          md="10"
                                                          sm="10"
                                                          xs="10"
                                                        >
                                                          <div
                                                            alt="Sample"
                                                            className="labels-selection-img"
                                                            id="PopoverClick"
                                                            type="button"
                                                            style={{
                                                              backgroundColor:
                                                                data.color,
                                                            }}
                                                            // onClick={() => setLabelCard(true)}
                                                          >
                                                            <div
                                                              style={{
                                                                marginTop:
                                                                  "4px",
                                                              }}
                                                            >
                                                              {" "}
                                                              {data.label}
                                                            </div>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    )
                                                  }
                                                )
                                              : ""}
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <div className="d-flex flex-row">
                                      <button
                                        onClick={() => setLabelCard(false)}
                                        style={{
                                          background: "#f00707b7",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "6px",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        Close
                                      </button>
                                      <button
                                        onClick={() => {
                                          addLabelDetails()
                                        }}
                                        className="mx-2"
                                        style={{
                                          background: "#34c28f",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "6px",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </Modal.Footer>
                                </Modal>
                              )}
                            </Col>
                            <Col
                              xl="6"
                              lg="6"
                              md="6"
                              sm="6"
                              xs="6"
                              style={{ marginLeft: "-40px" }}
                              className="d-flex flex-column"
                            >
                              <h5>
                                Sub Department
                              </h5>
                              <Row className="d-flex flex-row">
                                <Col xl="8" lg="8" md="8" sm="8" xs="8">
                                  <div>
                                    <Select
                                      name="subLabel"
                                      value={subLabel}
                                      placeholder="Select Sub Label"
                                      onChange={(e) => setSubLabel(e)}
                                      options={subLabelOptions}
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xl="2"
                                  lg="2"
                                  md="2"
                                  sm="2"
                                  xs="2"
                                  style={{ marginLeft: "-27px" }}
                                >
                                  <div
                                    className="label-img-plus mx-2"
                                    id="PopoverClick"
                                    style={{
                                      position: "relative",
                                    }}
                                    type="button"
                                    onClick={() => setSubLabelCard(true)}
                                  >
                                    <p
                                      style={{
                                        position: "absolute",
                                        top: "7px",
                                        left: "11.5px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </p>
                                  </div>
                                </Col>
                              </Row>

                              {subLabelCard && (
                                <Modal
                                  backdrop="static"
                                  show={subLabelCard}
                                  onHide={() => setSubLabelCard(false)}
                                  size="sm"
                                  style={{ borderRadius: "4px" }}
                                >
                                  <Modal.Header className="d-flex flex-row">
                                    <div className="d-flex flex-row justify-content-center">
                                      <h5>Sub Labels</h5>
                                    </div>
                                    <div className="d-flex flex-row justify-content-end">
                                      <i
                                        className="fa fa-times"
                                        onClick={() => setSubLabelCard(false)}
                                        style={{
                                          // color: "#ffffff",
                                          fontSize: "14px",
                                          cursor: "pointer",
                                          float: "right",
                                          // position: "absolute",
                                          // top: "18px",
                                          // left: "264px",
                                        }}
                                      ></i>
                                    </div>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row className="mt-2">
                                      <Col
                                        xl="12"
                                        lg="12"
                                        md="12"
                                        sm="12"
                                        xs="12"
                                      >
                                        <Input
                                          name="subLabelSearch"
                                          value={subLabelSearch}
                                          placeholder="Enter The Sub Label"
                                          onChange={(e) =>
                                            setSubLabelSearch(e.target.value)
                                          }
                                          // options={subLabelOptions}
                                        />
                                      </Col>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <div className="d-flex flex-row">
                                      <button
                                        onClick={() => setSubLabelCard(false)}
                                        style={{
                                          background: "#f00707b7",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "6px",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          addSubLabelDetails()
                                        }}
                                        className="mx-2"
                                        style={{
                                          background: "#34c28f",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "6px",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </Modal.Footer>
                                </Modal>
                              )}
                            </Col>
                          </Row>
                        </Col>*/}
                          {/* Employee Label */}
                          <Col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            className="mt-1 mx-3"
                          >
                            <Row className="d-flex flex-row">
                              <Col
                                xl="4"
                                lg="4"
                                md="12"
                                sm="12"
                                style={{
                                  // paddingRight: "70px",
                                  // paddingLeft: "36px",
                                  marginLeft: "20px",
                                }}
                              >
                                <div className="d-flex flex-row justify-content-between mt-4">
                                  <h5 style={{ color: "#172b4d" }}>
                                    {/* {addNewLabel ? "New Label" : "Label"} */}
                                    Label{" "}
                                    <span
                                      style={{ color: "red" }}
                                      className="ticket-required"
                                    >
                                      *
                                    </span>
                                  </h5>
                                  {/* <div
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setAddNewLabel(!addNewLabel)}
                                >
                                  Add New
                                </div> */}
                                </div>
                                {/* {addNewLabel ? (
                                <>
                                  <Input
                                    name="newLabelData"
                                    value={newLabelData}
                                    onChange={(e) =>
                                      setNewLabelData(e.target.value)
                                    }
                                    placeholder="Enter New Label"
                                  />
                                </>
                              ) : (
                                <ReactSearchAutocomplete
                                  key={resetSubManager}
                                  name="salesAgent"
                                  items={employeeLabelData}
                                  value={employeeLabel}
                                  type="autoComplete"
                                  resultStringKeyName="label"
                                  showIcon={false}
                                  fuseOptions={fuseOptions}
                                  onSelect={(e) => {
                                    handleEmployeeLabel(e)
                                    if (e) {
                                      dispatch(
                                        ticketQueryAction.loadEmployeeSubLabels(
                                          {
                                            employeeLabelId: e.value,
                                            employeeId: empId,
                                          }
                                        )
                                      )
                                    }
                                  }}
                                  onChange={(e) =>
                                    setEmployeeLabelName(e.target.value)
                                  }
                                  placeholder="Enter Label" // Search on both fields
                                  styling={{
                                    height: "34px",
                                    border: "1px solid #ced4da",
                                    borderRadius: "4px",
                                    backgroundColor: "white",
                                    boxShadow: "none",
                                    hoverBackgroundColor: "#E40D8C",
                                    color: "black",
                                    fontSize: "12px",
                                    fontFamily: "Courier",
                                    iconColor: "green",
                                    clearIconMargin: "3px 8px 0 0",
                                    zIndex: 10,
                                  }}
                                />
                              )} */}
                                {/* <ReactSearchAutocomplete
                                key={resetSubManager}
                                name="salesAgent"
                                items={
                                  recordsMetaData.newLabelOptions
                                    ? recordsMetaData.newLabelOptions
                                    : []
                                }
                                value={employeeLabel}
                                type="autoComplete"
                                resultStringKeyName="label"
                                showIcon={false}
                                fuseOptions={fuseOptions}
                                onSelect={(e) => {
                                  handleEmployeeLabel(e)
                                  if (e) {
                                    dispatch(
                                      ticketQueryAction.loadEmployeeSubLabels({
                                        employeeLabelId: e.value,
                                        employeeId: empId,
                                      })
                                    )
                                  }
                                }}
                                onChange={(e) =>
                                  setEmployeeLabelName(e.target.value)
                                }
                                placeholder="Enter Label" // Search on both fields
                                styling={{
                                  height: "34px",
                                  border: "1px solid #ced4da",
                                  borderRadius: "4px",
                                  backgroundColor: "white",
                                  boxShadow: "none",
                                  hoverBackgroundColor: "#E40D8C",
                                  color: "black",
                                  fontSize: "12px",
                                  fontFamily: "Courier",
                                  iconColor: "green",
                                  clearIconMargin: "3px 8px 0 0",
                                  zIndex: 10,
                                }}
                              /> */}
                                <Select
                                  name="employeeLabel"
                                  value={employeeLabel}
                                  onChange={(e) => {
                                    handleEmployeeLabel(e)
                                    // if (e) {
                                    //   dispatch(
                                    //     ticketQueryAction.loadEmployeeSubLabels({
                                    //       employeeLabelId: e.value,
                                    //       employeeId: empId,
                                    //     })
                                    //   )
                                    // }
                                    setEmployeeLabelName(e.label)
                                  }}
                                  options={
                                    recordsMetaData.newLabelOptions
                                      ? recordsMetaData.newLabelOptions
                                      : []
                                  }
                                  placeholder="Select Label"
                                />
                                <div style={{ textTransform: "capitalize" }}>
                                  {simpleValidator.current.message(
                                    "Employee Label",
                                    employeeLabel,
                                    "required"
                                  )}
                                </div>
                                {/* {simpleValidator.current.messages(
                                "Label",
                                employeeLabel,
                                "required"
                              )} */}
                              </Col>
                              <Col
                                xl="4"
                                lg="4"
                                md="12"
                                sm="12"
                                style={
                                  {
                                    // paddingRight: "70px",
                                    // paddingLeft: "36px",
                                    // marginLeft: "20px",
                                  }
                                }
                              >
                                <div className="d-flex flex-row justify-content-between mt-4">
                                  <h5 style={{ color: "#172b4d" }}>
                                    {addNewLabel
                                      ? "New Employee Label"
                                      : "Employee Label"}
                                  </h5>
                                  <div
                                    style={{
                                      color: "blue",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => setAddNewLabel(!addNewLabel)}
                                  >
                                    Add New
                                  </div>
                                </div>
                                {addNewLabel ? (
                                  <>
                                    <Input
                                      name="newLabelData"
                                      value={newLabelData}
                                      onChange={(e) =>
                                        setNewLabelData(e.target.value)
                                      }
                                      placeholder="Enter New Sub Label"
                                    />
                                  </>
                                ) : (
                                  <ReactSearchAutocomplete
                                    key={resetManager}
                                    name="employeeSubLabel"
                                    items={recordsMetaData.labelData}
                                    value={employeeSubLabel}
                                    type="autoComplete"
                                    resultStringKeyName="label"
                                    showIcon={false}
                                    onSelect={(e) => {
                                      setEmployeeSubLabel(e)
                                    }}
                                    onChange={(e) =>
                                      setEmployeeSubLabel(e.target.value)
                                    }
                                    placeholder="Enter Sub Label"
                                    fuseOptions={fuseOptions}
                                    styling={{
                                      height: "34px",
                                      border: "1px solid #ced4da",
                                      borderRadius: "4px",
                                      backgroundColor: "white",
                                      boxShadow: "none",
                                      hoverBackgroundColor: "#E40D8C",
                                      color: "black",
                                      fontSize: "12px",
                                      fontFamily: "Courier",
                                      iconColor: "green",
                                      clearIconMargin: "3px 8px 0 0",
                                      zIndex: 10,
                                    }}
                                  />
                                )}
                              </Col>

                              <Col
                                xl="4"
                                lg="4"
                                md="12"
                                sm="12"
                                style={{
                                  // paddingRight: "70px",
                                  // paddingLeft: "36px",
                                  marginLeft: "20px",
                                }}
                              >
                                <div className="d-flex flex-row mt-4">
                                  <h5 style={{ color: "#172b4d" }}>
                                    Priority{" "}
                                    {/* <span
                                    style={{ color: "red" }}
                                    className="ticket-required"
                                  >
                                    *
                                  </span> */}
                                  </h5>
                                </div>
                                <Select
                                  name="priority"
                                  value={priority}
                                  onChange={(e) => setPriority(e)}
                                  options={
                                    priorityMetaData
                                      ? priorityMetaData.priorityOptions
                                      : []
                                  }
                                  placeholder="Select Priority"
                                />
                              </Col>
                            </Row>
                          </Col>

                          <Col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            style={{ marginTop: "20px" }}
                          >
                            <Row className="d-flex flex-row">
                              <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <i
                                  className="fas fa-file"
                                  style={{ fontSize: "19px", marginTop: "0px" }}
                                ></i>

                                <h5
                                  // onClick={() => setEditableTicket(true)}
                                  style={{
                                    color: "#172b4d",
                                    marginLeft: "39px",
                                    marginTop: "-22px",
                                  }}
                                >
                                  Attachment{" "}
                                  {/* <span
                                  style={{ color: "red" }}
                                  className="ticket-required mx-2"
                                >
                                  *
                                </span> */}
                                </h5>
                              </Col>
                              <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <Row>
                                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                    <div
                                      className="mt-3"
                                      style={{
                                        padding: "0px 35px",
                                      }}
                                    >
                                      <Dropzone
                                        onDrop={(acceptedFiles) => {
                                          handleTicketAttachmentFiles(
                                            acceptedFiles
                                          )
                                        }}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div
                                            className="dropzone-img"
                                            style={{ height: "90px" }}
                                          >
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div
                                                className="dz-message needsclick"
                                                style={{ marginTop: "-61px" }}
                                              >
                                                <div className="mb-3">
                                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                </div>
                                                <h4>
                                                  Drop files here or click to
                                                  upload.
                                                </h4>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      {/* {simpleValidator.current.message(
                                      "ticketAttachmentFiles",
                                      ticketAttachmentFiles,
                                      "required"
                                    )} */}
                                      {/* <Input name="ticketAttachment" value={ticketAttachment} /> */}
                                    </div>
                                  </Col>
                                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                      style={{
                                        padding: "0px 35px",
                                      }}
                                    >
                                      {!isEmpty(ticketAttachmentFiles)
                                        ? ticketAttachmentFiles.map((f, i) => {
                                            return (
                                              <Card
                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                key={i + "-file"}
                                              >
                                                <div className="p-2">
                                                  <Row className="align-items-center">
                                                    <Col className="col-auto">
                                                      <img
                                                        data-dz-thumbnail=""
                                                        height="80"
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.name}
                                                        src={f.preview}
                                                      />
                                                    </Col>
                                                    <Col>
                                                      <Link
                                                        to="#"
                                                        className="text-muted font-weight-bold"
                                                      >
                                                        {f.name}
                                                      </Link>
                                                      <p className="mb-0">
                                                        <strong>
                                                          {f.formattedSize}
                                                        </strong>
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Card>
                                            )
                                          })
                                        : ""}
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl="6" lg="6" md="6" sm="6" xs="6">
                        <Row>
                          <Col xl="12" lg="12" md="12" sm="12" xs="12">
                            <div className="d-flex flex-row">
                              <i
                                className="fa fa-align-left"
                                style={{ fontSize: "19px", marginTop: "5px" }}
                              ></i>

                              <h5
                                // onClick={() => setEditableTicket(true)}
                                style={{
                                  color: "#172b4d",
                                  marginLeft: "18px",
                                  zIndex: 0,
                                }}
                              >
                                Description{" "}
                                <span
                                  style={{ color: "red" }}
                                  className="ticket-required mx-2"
                                >
                                  *
                                </span>
                              </h5>
                            </div>
                            <div
                              style={{
                                padding: "0px 36px",
                              }}
                            >
                              <ReactQuill
                                theme={"snow"}
                                value={ticketDescription}
                                onChange={setTicketDescription}
                                modules={modules}
                                style={{ height: "390px" }}
                                // className="rich-editor-style"
                                bounds={".rich-editor-style"}
                                formats={formats}
                                placeholder="Add the detailed description..."
                              />
                            </div>
                          </Col>
                          <Col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            style={{ marginTop: "100px" }}
                          >
                            <div
                              className="mb-3"
                              style={{ marginLeft: "40px" }}
                            >
                              {simpleValidator.current.message(
                                "ticketDescription",
                                ticketDescription,
                                "required"
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12" xl="12" sm="12" xs="12" className="mt-2">
                        <div
                          className="d-flex flex-row"
                          style={{ float: "right" }}
                        >
                          <Button
                            className="btn btn-danger"
                            onClick={() => setDataClear(true)}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            id="btnRefresh"
                            className="btn btn-success mx-2"
                            onClick={(e) => {
                              addTicketQuery(e)

                              //   setTimeout(() => {
                              //     setEditableText("")
                              //   }, 1500)
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}
RaiseTicket.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RaiseTicket)
)
